import {CalendarMonth, MailOutline} from '@mui/icons-material'
import ic_facebook from './Recursos/ic_face.svg'
import ic_insta from './Recursos/ic_insta.svg'
import ic_tik from './Recursos/ic_tik.svg'

export const NUMWASS = '593992709352'

export const Constantes = [
    {
        icono: CalendarMonth,
        nombre: 'Telefono',
        descripcion: '+593 992 709 352',
    },
    {
        icono: MailOutline,
        nombre: 'Correo',
        descripcion: 'administracion@magazalodge.com',
    },
    {
        icono: CalendarMonth,
        nombre: 'Direccion',
        descripcion: 'San Miguel de los Bancos - Camino a la cascada del amor - Recinto río blanco',
    },
]


export const LAT = 0.006014093247643645
export const LONG = -78.90427664018875

export const URLMAPA = `https://www.google.com/maps/dir/?api=1&destination=${LAT},${LONG},190&dir_action=navigate`

export const REDES = [
    {
        nombre: 'Facebook',
        icono: ic_facebook,
        url: 'https://www.facebook.com/magazalodge'
    },
    {
        nombre: 'Instagram',
        icono: ic_insta,
        url: 'https://www.instagram.com/magazalodge/?hl=es'
    },
    {
        nombre: 'Tiktok',
        icono: ic_tik,
        url: 'https://www.tiktok.com/@magazalodge'
    },
]

export const APARTADOS = ['Inicio', 'Servicios', 'Actividades', 'Contactos']

export const TIPOCLIENTE = ['Transportador', 'Vendedor', 'Ejecutivo', 'Turista']

export const ORIGENESRESERVAS = ['Recepcion', 'Pagina']